import { render, staticRenderFns } from "./FeaturedOffersMapComponent.vue?vue&type=template&id=5e5c3648"
import script from "./FeaturedOffersMapComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedOffersMapComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports